var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{staticStyle:{"position":"fixed","top":"50%","left":"50%","transform":"translate(-50%, -50%)"},attrs:{"indeterminate":"","color":"#28d9fb","width":"7","size":"70"}})}
var staticRenderFns = []

export { render, staticRenderFns }